import React, { Component } from 'react';
import { GoogleLogin } from 'react-google-login';
import { origin, saveKey } from "utils/Helper";
import { apiUrl } from 'Api/Api';
import axios from 'axios';
import { local_routes } from 'utils/Routes';
import './style.css';

class Google_Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      errorMessage: '',
      originData: window.localStorage.getItem('loginOrigin')
    };
  }

  handleSuccess = async (data) => {
    console.log("GOOGLE SUCCESS",data);
    this.setState({
      code: data.accessToken,
      errorMessage: '',
    });
    let auth_obj = {
        //access_token: data.code,
        access_token: data.accessToken,
        //callback_url: window.location.protocol + '//' + window.location.hostname + '/linkedin'
    }
    
    //return;

    let auth_response = await axios.post(`${apiUrl}authenticate/google`,auth_obj);
    console.log("AUTH RESPONSE",auth_response.data);
    let UserData = { "UserMail": null, "login_Auth_Res": auth_response.data }
    saveKey("UserData", JSON.stringify(UserData));
    if (this.state.originData) {
        if (this.state.originData === "pkCreation") {
            window.localStorage.removeItem('loginOrigin');
            window.location.href = `${local_routes.pkcreation}`;
        } else {
            // redirect back to loginOrigin
            window.localStorage.removeItem('loginOrigin');
            window.location.href = this.state.originData;
        }
    } else {
        window.location.href = origin;
    }
  }

  handleFailure = (error) => {
    console.log("GOOGLE ERROR",error);
    this.setState({
      code: '',
      errorMessage: error.errorMessage,
    });
    if (this.props.stopLoading) {
      this.props.stopLoading();
    }
    /*
    if (this.state.originData) {
        if (this.state.originData === "pkCreation") {
            window.localStorage.removeItem('loginOrigin');
            window.location.href = `${local_routes.pkcreation}`;
        } else {
            // redirect back to loginOrigin
            window.localStorage.removeItem('loginOrigin');
            window.location.href = this.state.originData;
        }
    } else {
        window.location.href = origin;
    }
    */
  }
  
  render() {
    const { code, errorMessage } = this.state;
    return (
      <div>
        <GoogleLogin
            clientId="251311553772-fishnbbvgskt0ol28nobmcrehl2j13sv.apps.googleusercontent.com"
            onFailure={this.handleFailure}
            onSuccess={this.handleSuccess}
            //scope="r_emailaddress r_liteprofile"
            //redirectUri={window.location.protocol + '//' + window.location.hostname + '/google'}
            render={({ onClick, disabled }) => (
                <div className="google-login">
                    <button onClick={onClick} disabled={disabled}><i className="fa fa-google" aria-hidden="true"></i>&nbsp;Google</button>
                </div>
            )}
            cookiePolicy={'single_host_origin'}
        />
        {/*
        {!code && <div>No code</div>}
        {code && <div>Code: {code}</div>}
        */}
        {errorMessage && <div>{errorMessage}</div>}
      </div>
    );
  }
}

export default Google_Login;